import { Link, useMatch, useResolvedPath } from "react-router-dom"

import logo1 from '../assets/v-drive-logo.png'
import logo2 from '../assets/v-rotor-logo.png'


export default function Home() {
  return (
    <div className="container">   
      <div className="page">
        <section className="align_center">
          <h1 >      
            Advanced Technologies
          </h1>
          <h4><i>Engineering beyond conventional boundaries.</i></h4>
        </section> 
        <p className='align_left'>
          We are developing independent engineering technologies addressing different challenges in space propulsion and energy conversion. Our projects are driven by the same ambition:
          &nbsp; <i>Rethink the architecture. Expand what’s possible.</i>
        </p>
        
      <hr className='line' /> 

      <section className="align_center">
        <Link to="/Drive">
          <h2>      
            V-Drive — Propellantless Propulsion Research
          </h2>           
        </Link>      
      </section> 

        <div className="grid-container">
          <div className="grid-item">
            <figure>
              <Link to="/Drive">
                <img src={logo1} className="logo-big" alt='' /> 
              </Link>
            </figure>
          </div>          
          <div className="grid-item">
            <p className='align_left'>
              V-Drive is an experimental propulsion technology investigating whether a fully self-contained, energy-driven system can generate a measurable directional force without the conventional expulsion of propellant.
            </p>
          </div>                 
        </div>   
        <section className="align_left">
          <p className='align_left'>
            The current development program is focused on improving measurement accuracy, eliminating experimental artefacts, independently validating the observed effects, and developing a pathway toward vacuum and space-based testing.
          </p>    
          <p>
              Potential applications include:
              <ul>
                <li>Spacecraft propulsion</li>
                <li>CubeSats and small satellites</li>
                <li>Long-duration spacecraft</li>
                <li>Attitude and orbital control</li>
                <li>Deep-space missions</li>
              </ul>

          </p>

          <p className='align_center'>
            <b>V-Drive is currently an experimental research project focused on validating the underlying propulsion principle.</b>
          </p> 
        </section>

      <hr className='line' /> 
      <section className="align_center">
        <Link to="/Rotor">
          <h2>      
            V-Rotor — Next-Generation Rotary Displacement Technology
          </h2>           
        </Link>          

      </section>

        <div className="grid-container">
          <div className="grid-item">
            <figure>
              <Link to="/Rotor">
                <img src={logo2} className="logo-big" alt='' /> 
              </Link>        
            </figure>
          </div>          
          <div className="grid-item">
            <p className='align_left'>
              V-Rotor is a separate project focused on developing a new rotary displacement architecture for engines, pumps, compressors, expanders, and other rotary energy-conversion systems.        
            </p>                      
    
          </div>         
        </div>   
        <section className="align_left">
          <p className='align_left'>
            The concept retains the fundamental advantages of a conventional vane-type rotary machine, including compact geometry, continuous rotary operation, and variable-volume working chambers. However, instead of conventional sliding vanes, V-Rotor uses blades connected directly to the rotating shaft.        
          </p>                      
          <p className='align_left'>
            This architecture is intended to address several longstanding limitations of conventional vane mechanisms, particularly continuous sliding wear, friction, sealing degradation, lubrication requirements, and thermal-management challenges.        
          </p>         
        </section>
        <section>                      
          <p className='align_left'>
            The design also provides an architecture compatible with conventional liquid-cooling systems, potentially allowing improved thermal control and reduced effects of differential thermal expansion.        
          </p>  
          <p className='align_left'>
            Depending on the configuration of the housing and inlet/outlet ports, the same basic rotary architecture may be adapted for different applications, including:        
          </p>
          <p className='align_center'>
            <ul className='my-ul'>
              <li>Internal combustion engines</li>
              <li>Pumps</li>
              <li>Compressors</li>
              <li>Expanders</li>
              <li>Hydraulic motors</li>
              <li>Pneumatic motors</li>
              <li>Power generation</li>
              <li>Automotive propulsion</li>
              <li>Marine propulsion</li>
              <li>Aerospace and unmanned systems</li>
            </ul>
          </p>
          <p className='align_center'>
            <b>V-Rotor is currently at the design stage, with prototype development and experimental validation planned. </b>
          </p>
          <p className='align_left'>
            
          </p>                        
        </section>

      </div>
    </div>
  );
};
